//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";

export default {
  props: {
    order: {},    
  },
  data() {
    return {
      confirm: false,      
      confirmDimension: 0,
      DimensionSettings: [],
      FilterDimensionSettings: [],
      SelectedValues: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0 },
    };
  },

  mounted: function() {
    this.initSelectBox();
  },

  computed: {
    ...mapState("main", ["projects", "departments", "dimensions"]),
  },

  methods: {
    ...mapActions("main", ["getDepartment", "getProject", "getDimensions"]),
    setDimensionOnConfirmedOrderItems() {
      if (this.confirmDimension == 1) this.setDimension1OnOrderItems();
      else if (this.confirmDimension == 2) this.setDimension2OnOrderItems();
      else if (this.confirmDimension == 3) this.setDimension3OnOrderItems();
      else if (this.confirmDimension == 4) this.setDimension4OnOrderItems();
      else if (this.confirmDimension == 5) this.setDimension5OnOrderItems();
      else if (this.confirmDimension == 6) this.setDimension6OnOrderItems();
      else if (this.confirmDimension == 7) this.setDimension7OnOrderItems();
      else if (this.confirmDimension == 8) this.setDimension8OnOrderItems();
      else if (this.confirmDimension == 9) this.setDimension9OnOrderItems();
    },
    setDimension1OnOrderItems() {
      this.order.orderItems.forEach((item) => {
        item.dimension1Id = this.order.dimension1Id;
      });
    },
    setDimension2OnOrderItems() {
      this.order.orderItems.forEach((item) => {
        item.dimension2Id = this.order.dimension2Id;
      });
    },
    setDimension3OnOrderItems() {
      this.order.orderItems.forEach((item) => {
        item.dimension3Id = this.order.dimension3Id;
      });
    },
    setDimension4OnOrderItems() {
      this.order.orderItems.forEach((item) => {
        if (item.dimension4Id && item.dimension4Id > 0) {
          item.dimension4Id = this.order.dimension4Id;
        }
      });
    },
    setDimension5OnOrderItems() {
      this.order.orderItems.forEach((item) => {
        item.dimension5Id = this.order.dimension5Id;
      });
    },
    setDimension6OnOrderItems() {
      this.order.orderItems.forEach((item) => {
        item.dimension6Id = this.order.dimension6Id;
      });
    },
    setDimension7OnOrderItems() {
      this.order.orderItems.forEach((item) => {
        item.dimension7Id = this.order.dimension7Id;
      });
    },
    setDimension8OnOrderItems() {
      this.order.orderItems.forEach((item) => {
        item.dimension8Id = this.order.dimension8Id;
      });
    },
    setDimension9OnOrderItems() {
      this.order.orderItems.forEach((item) => {
        item.dimension9Id = this.order.dimension9Id;
      });
    },

    valueChanged(dimension) {
      switch (dimension.dimension) {
        case "1":
          this.order.dimension1Id = this.SelectedValues[dimension.dimension];
          this.order.orderItems.forEach((item) => {
            if (item.dimension1Id && item.dimension1Id > 0) {
              // Need to ask for confirmation
              this.confirm = true;
              this.confirmDimension = 1;
            }
          });
          if (!this.confirm) this.setDimension1OnOrderItems();
          break;
        case "2":
          this.order.dimension2Id = this.SelectedValues[dimension.dimension];
          this.order.orderItems.forEach((item) => {
            if (item.dimension2Id && item.dimension2Id > 0) {
              this.confirm = true;
              this.confirmDimension = 2;
            }
          });
          if (!this.confirm) this.setDimension2OnOrderItems();
          break;
        case "3":
          this.order.dimension3Id = this.SelectedValues[dimension.dimension];
          this.order.orderItems.forEach((item) => {
            if (item.dimension3Id && item.dimension3Id > 0) {
              this.confirm = true;
              this.confirmDimension = 3;
            }
          });
          if (!this.confirm) this.setDimension3OnOrderItems();
          break;
        case "4":
          this.order.dimension4Id = this.SelectedValues[dimension.dimension];
          this.order.orderItems.forEach((item) => {
            if (item.dimension4Id && item.dimension4Id > 0) {
              this.confirm = true;
              this.confirmDimension = 4;
            }
          });
          if (!this.confirm) this.setDimension4OnOrderItems();
          break;
        case "5":
          this.order.dimension5Id = this.SelectedValues[dimension.dimension];
          this.order.orderItems.forEach((item) => {
            if (item.dimension5Id && item.dimension5Id > 0) {
              this.confirm = true;
              this.confirmDimension = 5;
            }
          });
          if (!this.confirm) this.setDimension5OnOrderItems();
          break;
        case "6":
          this.order.dimension6Id = this.SelectedValues[dimension.dimension];
          this.order.orderItems.forEach((item) => {
            if (item.dimension6Id && item.dimension6Id > 0) {
              this.confirm = true;
              this.confirmDimension = 6;
            }
          });
          if (!this.confirm) this.setDimension6OnOrderItems();
          break;
        case "7":
          this.order.dimension7Id = this.SelectedValues[dimension.dimension];
          this.order.orderItems.forEach((item) => {
            if (item.dimension7Id && item.dimension7Id > 0) {
              this.confirm = true;
              this.confirmDimension = 7;
            }
          });
          if (!this.confirm) this.setDimension7OnOrderItems();
          break;
        case "8":
          this.order.dimension8Id = this.SelectedValues[dimension.dimension];
          this.order.orderItems.forEach((item) => {
            if (item.dimension8Id && item.dimension8Id > 0) {
              this.confirm = true;
              this.confirmDimension = 8;
            }
          });
          if (!this.confirm) this.setDimension8OnOrderItems();
          break;
        case "9":
          this.order.dimension9Id = this.SelectedValues[dimension.dimension];
          this.order.orderItems.forEach((item) => {
            if (item.dimension9Id && item.dimension9Id > 0) {
              this.confirm = true;
              this.confirmDimension = 9;
            }
          });
          if (!this.confirm) this.setDimension9OnOrderItems();
          break;
        default:
          break;
      }
    },

    async initSelectBox() {
      this.DimensionSettings = JSON.parse(JSON.stringify(this.dimensions));

      if (!this.DimensionSettings) {
        this.DimensionSettings = await this.getDimensions().then(
          (result) => (this.DimensionSettings = result)
        );
      }

      this.DimensionSettings.forEach((dimension) => {
        dimension.dimensions.splice(0, 0, { number: null, id: null, name: "" });
        switch (dimension.dimension) {
          case "1":
            this.SelectedValues[dimension.dimension] = this.order.dimension1Id;
            break;
          case "2":
            this.SelectedValues[dimension.dimension] = this.order.dimension2Id;
            break;
          case "3":
            this.SelectedValues[dimension.dimension] = this.order.dimension3Id;
            break;
          case "4":
            this.SelectedValues[dimension.dimension] = this.order.dimension4Id;
            break;
          case "5":
            this.SelectedValues[dimension.dimension] = this.order.dimension5Id;
            break;
          case "6":
            this.SelectedValues[dimension.dimension] = this.order.dimension6Id;
            break;
          case "7":
            this.SelectedValues[dimension.dimension] = this.order.dimension7Id;
            break;
          case "8":
            this.SelectedValues[dimension.dimension] = this.order.dimension8Id;
            break;
          case "9":
            this.SelectedValues[dimension.dimension] = this.order.dimension9Id;
            break;
          default:
            break;
        }
      });

      // Deep clone : https://www.samanthaming.com/tidbits/70-3-ways-to-clone-objects/#_3-using-json
      this.FilterDimensionSettings = JSON.parse(
        JSON.stringify(this.DimensionSettings)
      );
    },

    getCustomDimensionFilter(val, update, dimension) {

      if (!this.DimensionSettings) {
        update();
        return;
      }
      update(() => {
        this.FilterDimensionSettings.forEach((value, index) => {
          var valContainsSemicolon = val.indexOf(": ") > 0;
          if (value.dimension === dimension.dimension) {
            var value2 = JSON.parse(JSON.stringify(value));
            this.DimensionSettings[index].dimensions = value2.dimensions.filter(
              (v) =>
                v.name.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
                (valContainsSemicolon &&
                  v.name
                    .toLowerCase()
                    .indexOf(val.split(": ")[1].toLowerCase()) > -1)
            );
          }
        });
      });
    },
  },
};
